import { classNames } from "@offstreetparking/design-system/utils";
import Image from "next/image";
import { forwardRef } from "react";
import { MobileNavButton } from "../MobileNavButton";

export type MobileTopBarProps = {
	isVisible: boolean;
	toggleMenu: () => void;
	companyLogo: { url: string; altText: string };
	isLoading?: boolean;
};

export const MobileTopBar = forwardRef<HTMLButtonElement, MobileTopBarProps>(
	({ isVisible, toggleMenu, companyLogo, isLoading }, ref) => {
		return (
			<div className="fixed top-0 flex w-full items-center justify-between border-neutral-faded border-b bg-white px-6 py-2.5">
				{!isLoading && (
					<Image
						priority
						src={companyLogo.url}
						width={0}
						height={0}
						sizes="175px"
						alt={companyLogo.altText}
						style={{ maxHeight: "32px", width: "auto" }}
					/>
				)}
				{isLoading && (
					<span
						style={{ width: 76, height: 18 }}
						className={classNames("flex animate-pulse bg-neutral-faded")}
					/>
				)}

				<MobileNavButton ref={ref} isVisible={isVisible} onClick={toggleMenu} />
			</div>
		);
	},
);

MobileTopBar.displayName = "MobileTopBar";
